<template>
    <div>
        <Breadcrumbs :type="type" :header="title" :url="url"></Breadcrumbs>
        <div class="flex items-center justify-between mb-6">
            <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset">
                <label class="block text-gray-700">Role:</label>
                <select v-model="form.role" class="form-select mt-1 w-full">
                    <option :value="null" />
                    <option value="user">User</option>
                    <option value="owner">Owner</option>
                </select>
                <label class="block mt-4 text-gray-700">Trashed:</label>
                <select v-model="form.trashed" class="form-select mt-1 w-full">
                    <option :value="null" />
                    <option value="with">With Trashed</option>
                    <option value="only">Only Trashed</option>
                </select>
            </search-filter>
            <Link class="btn-indigo" href="/backend/users/create">
            <span>Create</span>
            <span class="hidden md:inline">&nbsp;User</span>
            </Link>
        </div>
        <div class="bg-white rounded-md shadow overflow-x-auto">
            <table class="w-full whitespace-nowrap">
                <thead>
                    <tr class="text-left font-bold">
                        <th class="pb-4 pt-6 px-6">Name</th>
                        <th class="pb-4 pt-6 px-6">Email</th>
                        <th class="pb-4 pt-6 px-6">Role</th>
                        <th class="pb-4 pt-6 px-6" colspan="2">Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="user in users" :key="user.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                        <td class="border-t">
                            <Link class="flex items-center px-6 py-4 focus:text-orange-500"
                                :href="`/users/${user.id}/edit`">
                            <img v-if="user.photo" class="block -my-2 mr-2 w-5 h-5 rounded-full" :src="user.photo" />
                            {{ user.name }}
                            <icon v-if="user.deleted_at" name="trash"
                                class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
                            </Link>
                        </td>
                        <td class="border-t">
                            <Link class="flex items-center px-6 py-4" :href="`/backend/users/${user.id}/edit`"
                                tabindex="-1">
                            {{ user.email }}
                            </Link>
                        </td>
                        <td class="border-t">
                            <Link class="flex items-center px-6 py-4" :href="`/backend/users/${user.id}/edit`"
                                tabindex="-1">
                            {{ user.role_name }}
                            </Link>
                        </td>
                        <td class="border-t">
                            <Link class="flex items-center px-6 py-4" :href="`/backend/users/${user.id}/edit`"
                                tabindex="-1">
                            <status-level :status="user.status"></status-level>
                            </Link>
                        </td>
                        <td class="w-px border-t">
                            <Link class="flex items-center px-4" :href="`/backend/users/${user.id}/edit`" tabindex="-1">
                            <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                            </Link>
                        </td>
                    </tr>
                    <tr v-if="users.length === 0">
                        <td class="px-6 py-4 border-t" colspan="4">No users found.</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import Icon from '@/Shared/Icon'
    import pickBy from 'lodash/pickBy'
    import Layout from '@/Shared/Layout'
    import throttle from 'lodash/throttle'
    import mapValues from 'lodash/mapValues'
    import SearchFilter from '@/Shared/SearchFilter'
    import Breadcrumbs from '@/Shared/Breadcrumbs'
    import StatusLevel from '@/Shared/StatusLevel'
    export default {
        components: {
            Head,
            Icon,
            Link,
            SearchFilter,
            Breadcrumbs,
            StatusLevel
        },
        layout: Layout,
        props: {
            filters: Object,
            users: Array,
        },
        data() {
            return {
                form: {
                    search: this.filters.search,
                    role: this.filters.role,
                    trashed: this.filters.trashed,

                },
            }
        },
        watch: {
            form: {
                deep: true,
                handler: throttle(function () {
                    this.$inertia.get('/users', pickBy(this.form), { preserveState: true })
                }, 150),
            },
        },
        methods: {
            reset() {
                this.form = mapValues(this.form, () => null)
            },
        },
    }
</script>
